<template>
  <div>
    <Sidebar v-if="isAuthenticated" />
    <LoadingBottomCard
      v-if="showProgress"
      :processed="processed"
      :enqueued="enqueued"
    />
    <Navbar />
    <Toaster />
    <div class="p-2" style="overflow-x: hidden">
      <router-view />
    </div>
    <MaintenanceModal />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Navbar from '@/components/pages/home/components/navbar/index.vue'
import Sidebar from '@/components/pages/home/components/sidebar/Sidebar.vue'

import { userMappers } from '@/store/modules/user'
import { toastMapper } from '@/store/modules/toast'
import MobileWidthMixin from '@/mixins/mobile'
import Toaster from '@/components/pages/home/components/Toaster.vue'
import { loadingMapper } from '@/store/modules/loading'
import { socketURL, socketPath } from '@/api/httpAxios'
import io, { Socket } from 'socket.io-client'
import { MaintenanceInfo } from 'interfaces/notifications'
import MaintenanceModal from '@/components/pages/home/components/MaintenanceModal.vue'
import { notificationsMapper } from '@/store/modules/notifications'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters(['isAuthenticated']),
    ...loadingMapper.mapGetters(['showProgress']),
    ...loadingMapper.mapState(['processed', 'enqueued']),
    ...userMappers.mapState(['clientVersion']),
  },
  methods: {
    ...toastMapper.mapActions(['pushToast']),
    ...notificationsMapper.mapMutations(['setMaintenanceInfo']),
  },
})

@Component({
  components: {
    Navbar,
    Toaster,
    Sidebar,
    MaintenanceModal,
  },
  mixins: [MobileWidthMixin],
})
export default class Home extends Mappers {
  private socket!: typeof Socket
  mounted() {
    if (this.clientVersion) {
      const clientVersion = window.localStorage.getItem('client-version')
      if (clientVersion !== this.clientVersion.commit) {
        window.localStorage.setItem('client-version', this.clientVersion.commit)
        window.location.reload()
      }
    }

    if (!this.isAuthenticated) {
      return
    }
    this.socket = io(socketURL, { path: socketPath })

    this.socket.on('connect', () => {
      this.socket.emit('get-maintenance')
    })

    this.socket.on('maintenance-info', (data: MaintenanceInfo) => {
      this.setMaintenanceInfo(data)
    })
  }

  onReload() {
    location.reload()
  }
}
</script>
